export class InfraRoutes
{
    static Home: string = "/";
    // Database
    static DatabaseList: string = "/database/list";
    static DatabaseNew: string = "/database/new";
    static DatabaseView(id: string)
    {
        return `/database/${id}/view`;
    }
    static DatabaseEdit(id: string)
    {
        return `/database/${id}/edit`;
    }
    static DatabaseCopy(id: string)
    {
        return `/database/${id}/copy`;
    }
    // Alert
    static AlertList: string = "/alert/list";
    static AlertNew: string = "/alert/new";
    static AlertView(id: string)
    {
        return `/alert/${id}/view`;
    }
    static AlertEdit(id: string)
    {
        return `/alert/${id}/edit`;
    }
    static AlertCopy(id: string)
    {
        return `/alert/${id}/copy`;
    }
    // Cache
    static CacheList: string = "/cache/list";
    static CacheNew: string = "/cache/new";
    static CacheView(id: string)
    {
        return `/cache/${id}/view`;
    }
    static CacheEdit(id: string)
    {
        return `/cache/${id}/edit`;
    }
    static CacheCopy(id: string)
    {
        return `/cache/${id}/copy`;
    }
    // Cloud
    static CloudList: string = "/cloud/list";
    static CloudNew: string = "/cloud/new";
    static CloudView(id: string)
    {
        return `/cloud/${id}/view`;
    }
    static CloudEdit(id: string)
    {
        return `/cloud/${id}/edit`;
    }
    static CloudCopy(id: string)
    {
        return `/cloud/${id}/copy`;
    }
    // Environment
    static EnvironmentList: string = "/environment/list";
    static EnvironmentNew: string = "/environment/new";
    static EnvironmentView(id: string)
    {
        return `/environment/${id}/view`;
    }
    static EnvironmentEdit(id: string)
    {
        return `/environment/${id}/edit`;
    }
    static EnvironmentCopy(id: string)
    {
        return `/environment/${id}/copy`;
    }
    static EnvironmentSelect(project_id: string)
    {
        return `/project/${project_id}/environment/select`;
    }
    // Container
    static ContainerList: string = "/container/list";
    static ContainerNew: string = "/container/new";
    static ContainerView(id: string)
    {
        return `/container/${id}/view`;
    }
    static ContainerEdit(id: string)
    {
        return `/container/${id}/edit`;
    }
    static ContainerCopy(id: string)
    {
        return `/container/${id}/copy`;
    }
    // Incident
    static IncidentList: string = "/incident/list";
    static IncidentView(id: string)
    {
        return `/incident/${id}/view`;
    }
    // Kubernetes
    static KubernetesList: string = "/kubernetes/list";
    static KubernetesNew: string = "/kubernetes/new";
    static KubernetesView(id: string)
    {
        return `/kubernetes/${id}/view`;
    }
    static KubernetesEdit(id: string)
    {
        return `/kubernetes/${id}/edit`;
    }
    static KubernetesCopy(id: string)
    {
        return `/kubernetes/${id}/copy`;
    }
    // Messaging
    static MessagingList: string = "/messaging/list";
    static MessagingNew: string = "/messaging/new";
    static MessagingView(id: string)
    {
        return `/messaging/${id}/view`;
    }
    static MessagingEdit(id: string)
    {
        return `/messaging/${id}/edit`;
    }
    static MessagingCopy(id: string)
    {
        return `/messaging/${id}/copy`;
    }
    // Metric
    static MetricList: string = "/metric/list";
    static MetricNew: string = "/metric/new";
    static MetricView(id: string)
    {
        return `/metric/${id}/view`;
    }
    static MetricEdit(id: string)
    {
        return `/metric/${id}/edit`;
    }
    static MetricCopy(id: string)
    {
        return `/metric/${id}/copy`;
    }
    // Monitor
    static MonitorList: string = "/monitor/list";
    static MonitorNew: string = "/monitor/new";
    static MonitorView(id: string)
    {
        return `/monitor/${id}/view`;
    }
    static MonitorEdit(id: string)
    {
        return `/monitor/${id}/edit`;
    }
    static MonitorCopy(id: string)
    {
        return `/monitor/${id}/copy`;
    }
    // Project
    static ProjectList: string = "/project/list";
    static ProjectNew: string = "/project/new";
    static ProjectView(id: string)
    {
        return `/project/${id}/view`;
    }
    static ProjectEdit(id: string)
    {
        return `/project/${id}/edit`;
    }
    static ProjectCopy(id: string)
    {
        return `/project/${id}/copy`;
    }
    static ProjectDiagram(project_id: string, environment_id: string)
    {
        return `/project/${project_id}/environment/${environment_id}/diagram`
    }
    // Server
    static ServerList: string = "/server/list";
    static ServerNew: string = "/server/new";
    static ServerView(id: string)
    {
        return `/server/${id}/view`;
    }
    static ServerEdit(id: string)
    {
        return `/server/${id}/edit`;
    }
    static ServerCopy(id: string)
    {
        return `/server/${id}/copy`;
    }
    // Streaming
    static StreamingList: string = "/streaming/list";
    static StreamingNew: string = "/streaming/new";
    static StreamingView(id: string)
    {
        return `/streaming/${id}/view`;
    }
    static StreamingEdit(id: string)
    {
        return `/streaming/${id}/edit`;
    }
    static StreamingCopy(id: string)
    {
        return `/streaming/${id}/copy`;
    }
}